var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrTournamentMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.917 5.53a.488.488 0 01-.486.487h-1.945v4.452a.481.481 0 01-.486.487.481.481 0 01-.486-.487V6.017H9.57a.488.488 0 01-.486-.487c0-.272.213-.486.486-.486h4.86c.273 0 .487.214.487.486z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.848 13.347H5.152l-.077-.392c-.15-.76-.716-1.351-1.443-1.51l-.383-.083V4.639l.383-.084c.727-.158 1.293-.751 1.443-1.51l.077-.393h13.695l.076.393c.15.759.716 1.352 1.443 1.51l.383.084v6.723l-.383.082c-.727.16-1.293.752-1.443 1.511l-.076.392zm-.772-.972a2.88 2.88 0 011.702-1.768V5.392a2.875 2.875 0 01-1.702-1.767H5.925a2.875 2.875 0 01-1.703 1.767v5.215a2.88 2.88 0 011.703 1.768h12.15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.82 15.778h22.36a.486.486 0 00.487-.486V.708a.486.486 0 00-.486-.486H.82a.486.486 0 00-.487.486v14.584c0 .268.218.486.487.486zm21.875-.973H1.305V1.196h21.39v13.61z"
  })));
}
SvgPrTournamentMoney.displayName = 'PrTournamentMoney';
export default SvgPrTournamentMoney;